import {Inject, Injectable} from '@angular/core';
import {Response} from '@angular/http';
import {plainToClass} from 'class-transformer';
import {Observable} from 'rxjs/Observable';

import {Question} from 'shared/models/questions/question';
import {QuestionType} from 'shared/models/questions/question-type';
import {QuestionTypeFactoryService} from 'shared/questions/services/question-type-factory.service';
import {QuestionsOverviewHttpRepository} from './../repositories/questions-overview.repository.http';
import {IQuestionsOverviewRepository} from './../repositories/questions-overview.repository.interface';

@Injectable()
export class QuestionsOverviewService {

  constructor(@Inject('IQuestionsOverviewRepository') private questionsOverviewRepository: QuestionsOverviewHttpRepository,
              private questionTypeFactoryService: QuestionTypeFactoryService) { }

  public getQuestions(): Observable<Array<Question>> {
    return this.questionsOverviewRepository.getQuestions()
      .map((questions: Array<Question>) => {
        return this.mapToQuestions(questions);
      });
  }

  public deleteQuestion(id: string): Observable<void> {
    return this.questionsOverviewRepository.deleteQuestion(id);
  }

  private mapToQuestions(questions: Array<Question>): Array<Question> {
    return questions.map((question: Question) => {
      const questionType: QuestionType = this.questionTypeFactoryService
        .createQuestionType(question.type.name, question.type);
      question.type = questionType;

      return question;
    });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/questions/questions-overview/services/questions-overview.service.ts